<template>
    <main-layout>
        <div id="mainDiv" class="container has-text-dark">
            <H1 class="pageTitle">MANAGE SUBPACK</H1>
           
            <div class="top40"><b>Status:</b> {{sub.status | statusString}}</div>
            <div><b>{{sub.status | actionString}}</b> {{az.dateConvertAddAYear(sub.createDate)}}</div>
           
            <div v-show="!assVisible">
                <button class="button is-warning top20 is-small" @click="showAssigner" :disabled="sub.status == constants.status.SlinkInGracePeriod.longCode">Assign to a Slink</button>&nbsp;
                <button class="button is-warning top20 is-small" @click="removeReinstatePack(sub.slink, sub.status)">{{subsStatusAction}}</button>
            </div>
        
            <div v-show="assVisible" class="subAssigner top20">
                <div>Assign this pack to the following Slink:</div>
                <select class="select input top10" style="width: 250px" v-model="selectedSlink">
                    <option v-if="this.selectedSlink == 'Select...'" id="Select...">Select...</option>
                    <option v-for="(s, i) in slinkList" :key="i" :id="s.slink">{{s.slink}}</option>
                </select>
                <br>
                <button class="button is-warning top20" :disabled="selectedSlink == 'Select...'" @click="assignToSlink">SUBMIT</button>
                <button class="button top20" @click="assVisible = false">CANCEL</button>
            </div>
        </div>
    </main-layout>
</template> 
<script>

import MainLayout from '../layouts/Main.vue'
import constants from '../STATIC/constants.js'

export default {
    components: { MainLayout},
    props:{sub: Object},
    data: function(){
        return {
            az: az,
            action: 'Remove',
            constants: constants,
            assVisible: false,
            slinkList: [],
            selectedSlink: 'Select...'
        }
    },

    mounted: function(){
        if(this.sub == undefined){
            this.$router.push('/mng')
        }
    },

    methods: {
        removeReinstatePack: function(id, status, i){

            var self = this

            if(this.sub.status == constants.status.SlinkInGracePeriod.longCode){
                this.$router.push('/subsupdate?s=' + this.sub.subscriptionId )
                return
            }

            var toDo = status == constants.status.SlinkActive.longCode || status == constants.status.SlinkExistsNoUrl.longCode  ? 'remove' : 'reinstate';
            this.$root.loadedModalComponent = 'ModalAddRemPack';
            this.$root.modalPropsObj = {slink: null, callBack: callApi, pack: null, toDo: 'pack|' + toDo};
            this.$root.showModal = true;


            function callApi(){
        
                function worked(){
                    az.addRemSpinner(false, 'id', 'mainDiv');
                    self.sub.status = toDo == 'remove' ? 'SlinkPendingCancel' : 'SlinkActive';
                
                }
                function noWorked(){
                    az.addRemSpinner(false, 'id', 'mainDiv');
                    self.$root.showModalOK({message: 'There was an error updating the status. Please try again or contact support.'})
                }

                az.addRemSpinner(true, 'id', 'mainDiv');
                this.$root.apiClient.put('api/account/mngslink/sub', {subSlink: id, action: toDo}, worked, noWorked)
            }
        },

        showAssigner: function(){
            var self = this;

            this.assVisible = true;
            az.addRemSpinner(true, 'id', 'mainDiv');

            function worked(data){
                 az.addRemSpinner(false, 'id', 'mainDiv');
                 self.slinkList = data.slinks.Items
            }

            function noWorked(){
                 az.addRemSpinner(false, 'id', 'mainDiv');
                 this.$root.app.showModalOK({message: "There was an error retrieving your list of slinks. Please try again or contact support."})
            }
            this.$root.apiClient.get('api/account/slinknames', {}, worked, noWorked)
        },

        assignToSlink: function(){
            var self = this;

            az.addRemSpinner(true, 'id', 'mainDiv');

            function worked(data){
                if(data.result == 'ok'){
                  
                    self.$root.showModalOK({message: "You have successfully assigned this Subslink Pack. Don't forget to go the manage page of the Slink you attached it to so you can setup the subslink's redirect urls."})
                    self.$router.push('/mng')
                } else {
                    self.$root.showModalOK({message: "Sorry, there was an error completing your request. Please try again or contact support."})
                }

                az.addRemSpinner(false, 'id', 'mainDiv');
            }

            function noWorked(){
                 az.addRemSpinner(false, 'id', 'mainDiv');
            }
            this.$root.apiClient.put('api/account/mngslink/assignsub',  {slink: this.selectedSlink, subSlink: this.sub.slink}, worked, noWorked)
        
        }
    }, 
    computed: {
        subsStatusAction: function(){
            if(this.sub.status == constants.status.SlinkPendingCancel.longCode){
                return 'Add back to Subscription'
            } else if(this.sub.status == constants.status.SlinkInGracePeriod.longCode){
                return 'Renew Subscription'
            } else {
                return 'Remove from Subscription'
            }
            
        }
    }
}

</script>


// WEBPACK FOOTER //
// src/pages/MngSub.vue